/* eslint-disable vue/max-attributes-per-line */
<template>
  <!-- <div class="top">222</div>
   -->
  <div class="top-nav">
    <el-image
      style="width: 8em"
      :src="require('@/assets/images/logo.png')"
    />
    <el-menu
      :default-active="'2'"
      mode="horizontal"
      style="display: inline-block"
    >
      <el-menu-item :index="'1'">
        <a
          style="text-decoration: none"
          href="http://www.zb-tech.com/index.html"
        >首页</a>
      </el-menu-item>
      <el-menu-item :index="'2'">
        <a
          style="text-decoration: none"
          href="http://www.zb-tech.com/zbhome/productlist.html"
        >产品方案</a>
      </el-menu-item>
      <el-menu-item :index="'3'">
        <a
          style="text-decoration: none"
          href="http://www.zb-tech.com/zbhome/usercase.html"
        >用户案例</a>
      </el-menu-item>
      <!-- <el-menu-item :index="4">
        <a
          style="text-decoration:none"
          href="http://www.zb-tech.com/zbhome/about.html"
        >关于我们</a>
      </el-menu-item> -->
    </el-menu>
  </div>
  <div class="introduce">
    <div class="centent">
      <!-- <img src="@/assets/images/banner.png" /> -->
      <el-carousel style="width: 1600px;  margin: 0 auto" height="500px">
        <el-carousel-item
          v-for="(item, index) in imageList"
          :key="'custmon' + index"
          style="width: 1600px;"
        >
          <el-image style="width: 100%" :src="item" />
        </el-carousel-item>
      </el-carousel>

      <!-- <el-image :src="" /> -->
    </div>
  </div>
  <div
    class="detail"
    style="
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 900px;
      margin: 0 auto;
    "
  >
    <template
      v-for="(item, index) in detailList"
      :key="index"
    >
      <detailBox
        style="width: 30%; margin-top: 50px"
        :title="item.title"
        :icon="item.icon"
        :content="item.content"
      />
    </template>
  </div>
  <div class="footer">
    <div class="contact">
      <div class="footer-title">联系我们</div>
      <div>电 话：0571-86772798，89988291/2/3</div>
      <div>传 真：0571-86772798转801</div>
      <div>邮箱：zhongbao@zb-tech.com</div>
      <div>杭州市西湖区文一西路588号西溪首座A2-1，5楼</div>
    </div>
    <div class="followUs">
      <div class="footer-title">关注我们</div>
      <div>
        <el-image
          style="width: 150px; height: 150px"
          :src="require('@/assets/images/wechat.jpg')"
        />
      </div>
    </div>
  </div>
  <div class="copyright">
    <div style="text-align: center">关于中宝 联系我们 使用条款 人才招聘</div>
    <div style="text-align: center">
      浙ICP备05002488号 Copyright 2003-2017 ZhongBao Technology All Rights
      Reserved
    </div>
  </div>
</template>

<script>
import detailBox from "components/detailBox";
export default {
  components: {
    detailBox,
  },
  setup() {
    return {
      imageList: [
        require("@/assets/images/1.png"),
        require("@/assets/images/2.png"),
      ],
      detailList: [
        {
          icon: "#icon-Icon-Two-tone-Activity",
          title: "强大的医药大数据支持",
          content:
            "打通中宝医药大数据平台，为企业经营管理提供决策支持。助力企业提升核心竞争力。",
        },
        {
          icon: "#icon-Icon-Two-tone-Buy",
          title: "全面的采购解决方案",
          content:
            "支持各种业务场景下的采购决策，包括：新开门店采购、配送缺货采购、门店订货采购、按补货点采购、按动销采购等。",
        },
        {
          icon: "#icon-Icon-Two-tone-User",
          title: "自动化仓库解决方案",
          content:
            "用电子标签自动定位拣货位置。采用一批一位的精细化货位方案，实现仓库管理零差错。",
        },
        {
          icon: "#icon-Icon-Two-tone-Home",
          title: "门店营销解决方案",
          content:
            "支持组合销售、满额换购、满量换购、会员日特价等多种促销方案。支持售药机对接、互联网处方对接。",
        },
        {
          icon: "#icon-Icon-Two-tone-Work",
          title: "会员CRM解决方案",
          content:
            "支持新会员自动送券、消费自动送券、会员标签管理。支持会员短信推送、微信推送等。",
        },
        {
          icon: "#icon-Icon-Two-tone-Bag",
          title: "财务管理",
          content:
            "支持采购返利管理、应付应收预警管理、预付款管理、发票勾兑、付款审批流程管理等。支持与主流财务系统进行对接，自动生成凭证。",
        },
        {
          icon: "#icon-Icon-Two-tone-Shield",
          title: "质量管理",
          content:
            "支持事前预警，降低质量风险。支持事中自动提醒，实现质量管理实时审核。支持事后商品台账批次管理，全流程可追溯。",
        },
        {
          icon: "#icon-Icon-Two-tone-Chart",
          title: "数据中心",
          content: "支持进销存全方位数据查询、同比分析、环比分析。",
        },
        {
          icon: "#icon-Icon-Two-tone-Send",
          title: "移动互联网",
          content: "支持手机盘点、移动审方、移动收货、门店日报等功能。",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.copyright {
  background: #2f3449;
  border-top: 1px solid white;
  font-size: 12px;
  color: white;
}
.footer {
  display: flex;
  background: #2f3449;
  justify-content: space-around;
  margin-top: 30px;
}
.contact {
  div {
    text-align: left;
    line-height: 2.5em;
    color: white;
  }
  .footer-title {
    font-size: 18px;
    font-weight: 900;
  }
}
.followUs {
  .footer-title {
    font-size: 18px;
    font-weight: 900;
    color: white;
    text-align: left;
    line-height: 2.5em;
  }
}
</style>
